import Axios from 'axios';
import { clearUserDataFromStorage } from './utils';

/**
 * When the API returns 401 on a request that sent a Bearer token, clear the
 * stored token so subsequent requests go out anonymously. We don't redirect
 * to /login or dispatch LOGOUT here — public pages (e.g. /quote/...) should
 * keep rendering, and full session teardown only belongs in explicit logout
 * flows (which already wipe redux state via the LOGOUT action). Requests that
 * never carried a Bearer token (e.g. wrong password on /login) are ignored.
 */
let interceptorInstalled = false;

function requestHadBearerToken(config: { headers?: Record<string, unknown> } | undefined): boolean {
  const h = config?.headers;
  if (!h) return false;
  const auth = (h.Authorization ?? h.authorization) as string | undefined;
  return typeof auth === 'string' && auth.toLowerCase().startsWith('bearer ');
}

export function setupAxios401Interceptor(): void {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  Axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status !== 401) {
        return Promise.reject(error);
      }
      if (!requestHadBearerToken(error.config)) {
        return Promise.reject(error);
      }
      clearUserDataFromStorage();
      return Promise.reject(error);
    }
  );
}
